'use client';

import { c as _c } from "react/compiler-runtime";
import type { GetCareersListOutputDTO } from '@algoacademy/backend/modules/career/endpoints/queries/get-careers-list/output.dto';
import { Button } from '@algoacademy/design-system/web/actions/Button';
import { Link } from '@algoacademy/design-system/web/actions/Link';
import { Badge } from '@algoacademy/design-system/web/data-display/Badge';
import { LightCard } from '@algoacademy/design-system/web/data-display/Card';
import { VerticalSpacer } from '@algoacademy/design-system/web/layouts/VerticalSpacer';
import { H2, H4 } from '@algoacademy/design-system/web/marketing/typography/Heading';
import { PlusIcon } from '@heroicons/react/24/solid';
import { useSearchParams } from 'next/navigation';
import { Fragment } from 'react';
import { cn } from '@/app/_lib/utils';
import { ReadMoreButton } from '@/app/(marketing-site)/_components/ReadMoreButton';
import type { JobOfferInTheListDTO } from '../../page';
export function JobOfferList(t0) {
  const $ = _c(27);
  const {
    jobOfferList,
    canManageJobOffers
  } = t0;
  const searchParams = useSearchParams();
  let t1;
  if ($[0] !== searchParams) {
    t1 = searchParams.get("oferta");
    $[0] = searchParams;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const currentJobOfferId = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <H2>Oferty pracy</H2>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== canManageJobOffers) {
    t3 = canManageJobOffers && <Button href="/kariera?mode=create" className="w-full"><PlusIcon />Dodaj ofertę pracy</Button>;
    $[3] = canManageJobOffers;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t3) {
    t4 = <div className="space-y-6 text-center lg:text-left">{t2}{t3}</div>;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== canManageJobOffers || $[8] !== currentJobOfferId || $[9] !== jobOfferList) {
    let t6;
    if ($[11] !== canManageJobOffers || $[12] !== currentJobOfferId) {
      t6 = jobOffer => {
        const isActive = currentJobOfferId === btoa(jobOffer.id);
        return <Fragment key={jobOffer.positionName}><Link href={canManageJobOffers ? `/kariera?oferta=${btoa(jobOffer.id)}&mode=edit` : `/kariera?oferta=${btoa(jobOffer.id)}`}><LightCard className={cn("cursor-pointer p-6", isActive && "outline-2 outline-algoprimary")}><div className="flex flex-row justify-between"><H4>{jobOffer.positionName}</H4>{canManageJobOffers && <div>{jobOffer.isActive ? <Badge className="bg-green-100 font-semibold text-green-700">Aktywna</Badge> : <Badge className="bg-blue-100 font-semibold text-algoprimary">Nieaktywna</Badge>}</div>}</div><div className="h-2" /><p className="text-slate-600 text-sm">{jobOffer.description}</p></LightCard></Link><div className="h-4" /></Fragment>;
      };
      $[11] = canManageJobOffers;
      $[12] = currentJobOfferId;
      $[13] = t6;
    } else {
      t6 = $[13];
    }
    t5 = jobOfferList.map(t6);
    $[7] = canManageJobOffers;
    $[8] = currentJobOfferId;
    $[9] = jobOfferList;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[14] !== t5) {
    t6 = <section id="desktop-view" className="hidden lg:flex lg:flex-row"><section className="w-96 space-y-4">{t5}</section></section>;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== canManageJobOffers || $[17] !== jobOfferList) {
    let t8;
    if ($[19] !== canManageJobOffers) {
      t8 = jobOffer_0 => <Fragment key={jobOffer_0.positionName}><LightCard className="p-6"><div className="flex flex-row flex-wrap justify-between gap-2"><H4>{jobOffer_0.positionName}</H4><div>{jobOffer_0.isActive ? <Badge className="bg-green-100 font-semibold text-green-700">Aktywna</Badge> : <Badge className="bg-blue-100 font-semibold text-algoprimary">Nieaktywna</Badge>}</div></div><div className="h-2" /><p className="text-slate-600 text-sm">{jobOffer_0.description}</p><div className="h-4" /><ReadMoreButton title={"Czytaj wi\u0119cej"} href={canManageJobOffers ? `/kariera?oferta=${btoa(jobOffer_0.id)}&mode=edit` : `/kariera?oferta=${btoa(jobOffer_0.id)}`} /></LightCard><VerticalSpacer size="content" /></Fragment>;
      $[19] = canManageJobOffers;
      $[20] = t8;
    } else {
      t8 = $[20];
    }
    t7 = jobOfferList.map(t8);
    $[16] = canManageJobOffers;
    $[17] = jobOfferList;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[21] !== t7) {
    t8 = <section id="mobile-view" className="lg:hidden">{t7}</section>;
    $[21] = t7;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  let t9;
  if ($[23] !== t4 || $[24] !== t6 || $[25] !== t8) {
    t9 = <main className="w-full space-y-6 lg:flex lg:flex-col">{t4}{t6}{t8}</main>;
    $[23] = t4;
    $[24] = t6;
    $[25] = t8;
    $[26] = t9;
  } else {
    t9 = $[26];
  }
  return t9;
}